// extracted by mini-css-extract-plugin
module.exports = {"container":"club_container__YKtRz","span":"club_span__64unm","checkbox":"club_checkbox__QAg9F"};